<script>
    import {ZegoClient} from 'webrtc-zego';
    const OSS = require('ali-oss');

    const ZegoTokenUrl = 'https://wsliveroom-alpha.zego.im:8282/token';
    const Zego = new ZegoClient();
    const OssClient = new OSS({
        accessKeyId: 'LTAI4G4c6Hf2zSvt16ZWN43q',
        accessKeySecret: 'DpL78YjcjIG9aFIF7dPoPnWYAq7yn0',
        bucket: 'stork',
        region: 'oss-cn-chengdu',
        secure: true,
        dir: 'chat'
    });

    let ZegoConfig = {
        appid: 372724454,
        idName: (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1) + new Date().getTime(),
        nickName: 'u' + new Date().getTime(),
        server: 'wss://webliveroom372724454-api.zego.im/ws',
        logLevel: 0,
        logUrl: 'wss://weblogger372724454-api.zego.im/log',
        audienceCreateRoom: false,
        testEnvironment: false
    };

    let ZegoSeq = 1;
    let adminStreamID = '';
    let usStreamID = '';
    let operaStreamID = '';
    let roomId = '';
    let isUSLandscape = false;
    let DestoryRoomMessage = "4B7BE6660CCE40E51FC58284C653007C";
    let ServerUrl = 'https://remoteserver.storkhealthcare.cn';

    export default {
        OssClient,
        ZegoTokenUrl,
        Zego,
        ZegoConfig,
        ZegoSeq,
        adminStreamID,
        usStreamID,
        isUSLandscape,
        operaStreamID,
        roomId,
        DestoryRoomMessage,
        ServerUrl
    }

</script>

// 上传dist文件命令
scp -r /Users/prophet/Desktop/Workspace/Web/StorkRemote_Web/dist/* stork@39.104.13.89:/home/stork/mytools/filebrowser/stork/remote